import type { Signal } from '@preact/signals-react'
import { signal } from '@preact/signals-react'

export class Availability {
  productId: Signal<string>
  availableToSell: Signal<number | null>
  inStockData: Signal<string | null>
  isAvailable: Signal<boolean>
  isStockThresholdReached: Signal<boolean>
  oneLeft: Signal<boolean>
  preOrder: Signal<boolean>
  showBadge: Signal<boolean>

  constructor(
    productId: string,
    availableToSell: number | null,
    inStockData: string | null,
    isAvailable: boolean,
    isStockThresholdReached: boolean,
    oneLeft: boolean,
    preOrder: boolean,
    showBadge: boolean,
  ) {
    this.productId = signal(productId)
    this.availableToSell = signal(availableToSell)
    this.inStockData = signal(inStockData)
    this.isAvailable = signal(isAvailable)
    this.isStockThresholdReached = signal(isStockThresholdReached)
    this.oneLeft = signal(oneLeft)
    this.preOrder = signal(preOrder)
    this.showBadge = signal(showBadge)
  }
}
